import { type TranslationTree } from '@/i18n/types';

export const messages = {
  notFound: 'CEP não encontrado',
  invalid: 'CEP inválido',
  unavailable: 'Serviço de CEP indisponível. Preencha o endereço manualmente',
  genericError: 'Erro ao buscar o CEP',
} satisfies TranslationTree;
